const normalize = (value: unknown) => String(value ?? '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

/** Match every search term independently across searchable catalog fields. */
export const matchesCatalogSearch = (
	item: Record<string, any> | null | undefined,
	query: string,
	fields: string[] = ['name', 'code', 'description']
): boolean => {
	const tokens = String(query ?? '').toLowerCase().split(/\s+/).map(token => token.replace(/[^a-z0-9]/g, '')).filter(Boolean);
	if (!tokens.length) return true;
	const haystack = fields.map(field => String(item?.[field] ?? '')).join(' ').toLowerCase().replace(/[^a-z0-9]/g, '');
	return tokens.every(token => haystack.includes(token));
};

const explicitCategory = (material: Record<string, any> | null | undefined): string => normalize(material?.category);
const profileCode = (code: string) => code.startsWith('PROFILE') || /^A(CG|CS)PL/.test(code);

/** Profile-light builder only: strips remain distinct unless explicitly classified as profile. */
export const isProfileLight = (material: Record<string, any> | null | undefined): boolean => {
	const category = explicitCategory(material);
	if (category) return category === 'PROFILE' || category.includes('PROFILELIGHT');
	const code = normalize(material?.code);
	const details = [material?.name, material?.description, material?.type].map(normalize).join(' ');
	return profileCode(code) || details.includes('PROFILE');
};

/** Profile and strip products should not appear as point-light choices in False Ceiling. */
export const isProfileOrStripLight = (material: Record<string, any> | null | undefined): boolean => {
	const category = explicitCategory(material);
	if (category) return category === 'PROFILE' || category.includes('PROFILELIGHT') || category === 'STRIP' || category.includes('STRIPLIGHT');
	const code = normalize(material?.code);
	const details = [material?.name, material?.description, material?.type].map(normalize).join(' ');
	return profileCode(code) || code.startsWith('STRIP') || details.includes('PROFILE') || details.includes('STRIP');
};

export const isFalseCeilingPointLight = (material: Record<string, any> | null | undefined): boolean =>
	Boolean(material?.code) && !isProfileOrStripLight(material);
